export const DELIMITER = ".";

export const FILTER_KEYWORD = `filter${DELIMITER}`;

export const SORTBY_KEYWORD = `sort${DELIMITER}`;

export const PAGE_KEYWORD = "page";

export const QUERY_KEYWORD = "query";

export const PAGESIZE_KEYWORD = `pageSize`;

export const PER_PAGE_VALUES = [12, 24, 36, 48, 60, 72];

export const SORTBY_DEFAULT = `${SORTBY_KEYWORD}relevance=desc`;
export const PAGESIZE_DEFAULT = 36;
